import { cn as e } from "../shared/utils.js";
import { Button as t } from "../button/primitive/button.js";
import { Modal as n } from "../modal/index.js";
import { AlertCircleIcon as r, XCloseIcon as i } from "@systemeio/icons";
import { forwardRef as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { cva as c } from "class-variance-authority";
//#region src/confirmation-dialog/index.tsx
var l = c("flex size-11.5 shrink-0 items-center justify-center rounded-xl [&_svg]:size-5", {
	variants: { status: {
		normal: "bg-bg-accent-light [&_svg]:text-icon-accent",
		error: "bg-bg-error [&_svg]:text-icon-error",
		info: "bg-bg-tertiary [&_svg]:text-icon-primary"
	} },
	defaultVariants: { status: "normal" }
}), u = (e) => /* @__PURE__ */ o(n.Root, { ...e }), d = a((e, t) => /* @__PURE__ */ o(n.Close, {
	ref: t,
	...e
})), f = a(({ actions: a, backdropProps: c, children: u, className: f, closeProps: p, description: m, feedback: h, icon: g, showCloseButton: _ = !0, status: v, title: y, ...b }, x) => /* @__PURE__ */ s(n.Popup, {
	ref: x,
	backdropProps: {
		forceRender: !0,
		...c
	},
	className: e("tablet:p-6 p-4", f),
	showCloseButton: !1,
	size: "sm",
	"data-slot": "confirmation-dialog-popup",
	"data-testid": "confirmation-dialog-popup",
	...b,
	children: [
		/* @__PURE__ */ s("div", {
			className: "flex w-full justify-between gap-6",
			children: [/* @__PURE__ */ o("div", {
				className: l({ status: v }),
				children: g ?? /* @__PURE__ */ o(r, { "aria-hidden": !0 })
			}), _ && /* @__PURE__ */ o(d, {
				"aria-label": "Close",
				render: /* @__PURE__ */ o(t, {
					size: "icon-sm",
					type: "button",
					variant: "ghost-gray"
				}),
				...p,
				children: /* @__PURE__ */ o(i, {})
			})]
		}),
		/* @__PURE__ */ o(n.Title, {
			className: "tablet:text-3xl mt-4 text-2xl",
			children: y
		}),
		m && /* @__PURE__ */ o(n.Subtitle, {
			className: "mt-4",
			children: m
		}),
		u && /* @__PURE__ */ o("div", {
			className: "mt-4",
			children: u
		}),
		a && /* @__PURE__ */ o("div", {
			className: "tablet:[&>*]:w-auto tablet:[&>*]:flex-none mt-6 flex justify-end gap-3 [&>*]:flex-1",
			children: a
		}),
		h
	]
}));
u.displayName = "ConfirmationDialog.Root", f.displayName = "ConfirmationDialog.Popup", d.displayName = "ConfirmationDialog.Close";
var p = {
	Root: u,
	Popup: f,
	Close: d
};
//#endregion
export { p as ConfirmationDialog };
